'use strict';

var base64 = require('./base64.js');
var custEvent = require('./custEvent.js');

var uniqueId = 0,
    prefix = 'ctrip_sequence';

module.exports = function (sdk, config) {
    var sniff = sdk.sniff,

    // encodeParam = (param) => {
    //     param = encodeURIComponent(JSON.stringify(param));
    //     return sniff.ctripUseBase64 ? base64.encode(param) : param;
    // },
    decodeParam = function decodeParam(param) {
        return JSON.parse(sniff.ctripUseBase64 ? base64.decode(param) : decodeURIComponent(param));
    },
        callbacks = {};

    var bridge = sdk.util.extend({
        loadURL: function loadURL(scheme) {
            var iframe = document.createElement("iframe"),
                cont = document.body || document.documentElement;
            iframe.style.display = "none";
            iframe.setAttribute('src', scheme);
            cont.appendChild(iframe);
            setTimeout(function () {
                cont.removeChild(iframe);
                iframe = null;
            }, 200);
        },
        callNative: function callNative(param) {
            // @hongqi.gan 调整param encode
            // let paramString = encodeParam(param);
            var paramString = JSON.stringify(param);
            if (sniff.ios) {
                paramString = encodeURIComponent(paramString);
                paramString = sniff.ctripUseBase64 ? base64.encode(paramString) : paramString;
                bridge.loadURL(sniff.bridgeScheme + paramString);
            } else if (sniff.android) {
                // @hongqi.gan 增加声明，已经和ctrip沟通确认是bug不是全局变量
                var nativeModule = window[param.service + '_a'];
                if (nativeModule) {
                    var nativeFunction = nativeModule[param.action];
                    if (nativeFunction) {
                        // @hongqi.gan 调整context设置比较重要
                        nativeFunction.call(nativeModule, paramString);
                    }
                }
            } else if (sniff.winos) {
                window.external.notify(paramString);
            }
        },
        invoke: function invoke(service, action, param, tagName, callback) {
            var sequenceId = uniqueId++;
            param = param || {};
            param.service = service;
            param.action = action;
            param.callback_tagname = (tagName || prefix) + '_id=' + sequenceId;
            callbacks[sequenceId] = callback;
            bridge.callNative(param);
        }
    }, custEvent);

    var callCallback = function callCallback(callback, param) {
        try {
            callback.call(sdk, param);
        } catch (e) {
            config.debug && console.error('[HySDK] Callback Function Error', e);
        }
    };

    // @hongqi.gan 7.2引入首次web_view_finished_did 不会触发，增加轮询
    var n = 0;
    var checkWVFL = setInterval(function () {
        if (window.finished_load) {
            //检查native是否错过webviewfinishload事件下发
            checkWVFL && clearInterval(checkWVFL);
            execCallback(window.finished_load);
        }
        if (n >= 50) {
            checkWVFL && clearInterval(checkWVFL);
            // 超时的话，返回空值，忽略继续
            execCallback("");
        }
    }, 200);
    n++;

    var web_view_finished_did_flag = false;
    var execCallback = function execCallback(data) {
        var response;
        try {
            response = decodeParam(data);
        } catch (e) {
            config.debug && console.warn(data + ' cannot decode.');
        }
        if (response) {
            var tagname = (response.tagname || '').split('_id=')[0],
                param = response.param || {},
                sequenceId = (response.tagname || '').split('_id=')[1];

            param.errorCode = response.error_code; // @cuiyi 增加error_code，部分api需要这个做成功判断

            // 低版本也不会触发两次web_view_finished_did
            // 高版本是异步回调,定时也会触发一次
            if (tagname === 'web_view_finished_did') {
                if (web_view_finished_did_flag) {
                    return;
                }

                web_view_finished_did_flag = true;
            }

            if (sequenceId) {
                if (callbacks[sequenceId]) {
                    var callback = callbacks[sequenceId];
                    delete callbacks[sequenceId];
                    callCallback(callback, param);
                }
            }
            if (tagname) {
                bridge.trigger(tagname, param);
                sdk.ctrip.trigger(tagname, param);
            }
        }
    };

    global.app = window.app || {};

    global.app.callback = function (data) {
        config.debug && console.info(data);
    };

    global.__writeLocalStorage = function (key, jsonValue) {
        if (jsonValue && typeof jsonValue === 'string') {
            localStorage.setItem(key, jsonValue);
        }
    };

    // Native call these?
    global.Internal = {
        appVersionNotSupportCallback: function appVersionNotSupportCallback(data) {
            config.debug && console.warn(data);
        },
        paramErrorCallback: function paramErrorCallback(data) {
            config.debug && console.warn(data);
        }
    };

    global.__bridge_callback = execCallback;

    return bridge;
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/lib/bridge.js
// module id = 53
// module chunks = 1 4